/**
 * Wrapper for sharing on social media
 *
 * Usage: (example) add the following attribute to a share element:
 *
 *      <a ... data-share='{ "type": "facebook", "url": "http://opgelicht.avrotros.nl", "title": "The title" }'></a>
 *
 * Note: Make sure you define a valid `href`, which will be used when social sharing is disabled in the NPO cookies.
 *
 * @param {object=} options (optional) Configuration, should at least contain `type` and `url`.
 * @constructor
 */
export default class Sharer {
    constructor (options) {
        this.options = options;
    }

    /**
     * returns the type of the class object
     */
    get type () {
        return this.options.type;
    }

    _data (platform) {
        const obj = {
            facebook: {
                shareUrl: 'https://www.facebook.com/sharer/sharer.php?',
                params: {
                    u: this.options.url
                }
            },
            twitter: {
                shareUrl: 'https://twitter.com/intent/tweet?',
                params: {
                    url: this.options.url,
                    text: this.options.title
                }
            },
            whatsapp: {
                shareUrl: 'whatsapp://send?',
                params: {
                    text: `${this.options.title} ${this.options.url}`
                },
            },
            googleplus: {
                shareUrl: 'https://plus.google.com/share?',
                params: {
                    url: this.options.url,
                    item: this.options.title
                }
            },
            email: {
                shareUrl: 'mailto:?',
                params: {
                    subject: this.options.title,
                    body: this.options.url
                }
            }
        };

        return obj[platform];
    }

    /**
     *
     * @returns {string|string|string}
     * @private
     */
    _createShareUrl () {
        const params = this._data(this.type).params || {};
        let shareUrl = this._data(this.type).shareUrl;

        // Create a string which contains the parameters from this.type
        for (const key in params) {
            shareUrl += `${key}=${encodeURIComponent(params[key])}&`
        }

        return shareUrl;
    }

    /**
     *
     * @returns {string}
     * @private
     */
    _openIn () {
        if (this._data(this.type).shareUrl === 'mailto:?') {
            return '_self';
        } else {
            return '_blank';
        }
    }

    /**
     *
     * @private
     */
    _createPopup () {
        // Check if social cookies are not accepted and if the cookiebar is not active, if so, trigger the AtCookieShowCC
        if (At.Util.Cookie.CcmCheck && !At.Util.Cookie.Allow('social') && !At.Util.CcInViewport()) {
            $('body').trigger('AtCookieShowCC');

            return;
            // Check if social cookies are not accepted and if the cookiebar is active, if so, trigger the AtCookieShowCC_if_CCInViewport
        } else if (At.Util.Cookie.CcmCheck && !At.Util.Cookie.Allow('social') && At.Util.CcInViewport()) {
            $('body').trigger('AtCookieShowCC_if_CCInViewport');

            return;
        }

        const width = 600;
        const height = 480;
        const left = (window.innerWidth / 2) - (width / 2) + window.screenX;
        const top = (window.innerHeight / 2) - (height / 2) + window.screenY;
        const popupParams = `scrollbars=no, width=${width}, height=${height}, top=${top}, left=${left}`;

        const popupWindow = window.open(this._createShareUrl(), this._openIn(), popupParams);
        popupWindow.focus();
    }
}
